<template>
  <div class="flex flex-row justify-center w-full">
    <div class="form-page form-1">
        <div id="root2">
            <sc-text v-if="fields.holdingMessage"
                     tag="p"
                     class="text-lg p-10 text-center"
                     :field="fields.holdingMessage" />
        </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'EntryForm',
  components: {
    ScText: Text,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    onMounted(() => {
      if (!props.fields?.holdingMessage?.value?.trim()) {
        const rewardsWidget = document.createElement('script');
        rewardsWidget.setAttribute(
          'src',
          'https://assets-emea.rewards.heineken.com/libs/widget/3.4.3/RewardsWidget.3.4.3.js'
        );

        // Wait for the script to load before initializing the widget
        rewardsWidget.onload = () => {
          // eslint-disable-next-line no-undef
          new Rewards.RewardsWidget({
            campaignId: 'ac4977df-7a8a-4e1c-a9ff-2bb43acd2cb4',
            apiUrl: 'https://api-emea.rewards.heineken.com/rewards-hint',
            apiKey: '536e5109ad1b4d939f3ae23354da634b',
            previewToken: 'b6502c31bdabd966cb97f69110dac04f373d2c4e',
            selector: '#root2',
          });
        };

        document.head.appendChild(rewardsWidget);
      }
    });
  },
};
</script>
<style>
@import url('https://assets-emea.rewards.heineken.com/cms/brandstyles/Fosters/styles.css');
</style>
